import React from 'react';
import { ScrollableViewport, AppBar, HeaderTabs } from '@ihsm/ui-shared';
import { PageContent } from 'shared/components/PageContent';
import { InnerPagePadding } from 'shared/components/InnerPagePadding';
import { PortfoliosFundTable } from '../components/PortfoliosFundTable';
import { usePortfolioPage } from '../hooks';
import { Controls } from '../components/Controls';
import { FUNDS_PAGE_OPTIONS, FUNDS_TABS } from '../constants';
import './PortfoliosFunds.scss';

export const PortfoliosFunds: React.FC = (): JSX.Element => {
  const { exporterRef, onExport } = usePortfolioPage();

  return (
    <PageContent
      className="portfolio-page"
      headerControls={
        <AppBar menuItems={FUNDS_PAGE_OPTIONS}>
          <HeaderTabs items={FUNDS_TABS} />
        </AppBar>
      }
      viewControls={<Controls onExport={onExport} />}
    >
      <InnerPagePadding>
        <ScrollableViewport vertical>
          <PortfoliosFundTable gridExportRef={exporterRef} />
        </ScrollableViewport>
      </InnerPagePadding>
    </PageContent>
  );
};
